// extracted by mini-css-extract-plugin
module.exports = {"root":"BrowsingLevelInput_root__duHsK","label":"BrowsingLevelInput_label__fYQk_","iconWrapper":"BrowsingLevelInput_iconWrapper__QXGXr"};